<template>
  <div :class="['answers ml-16', isRTLlang ? 'float-right' : '', 'ap-multiple-choice-answer']">
    <div v-for="option in options" :key="option.id">
      <div class="optionWrapper">
        <MultiChoiceTranslatedOption :lang="lang" :option="option" :translation-key-initial="translationKeyInitial" />
        <AlertMessage v-if="question.colorCodeEnabled && question.answer"
                      :backgroundColor="option.colorCoding && option.colorCoding.color"
                      :message="option.colorCoding && option.colorCoding.warningMessage" />
      </div>
    </div>

    <div v-if="otherOptionComment && isOtherOptionSelected">
      <span v-if="otherOptionComment.label">{{ otherOptionComment.label }}</span>
      <div v-if="otherOptionComment.value" class="other-answer-display-text pl-8">{{ otherOptionComment.value }}</div>
    </div>
  </div>
</template>

<script>
import AlertMessage from "@/components/common/alert-message.vue";
import * as MultiChoiceService from "@/components/common/multi-choice/multi-choice-service";
import MultiChoiceTranslatedOption from "@/components/common/multi-choice/multi-choice-translated-option";

export default {
  name: "site-facing-multi-choice-history",
  components: {
    MultiChoiceTranslatedOption,
    AlertMessage
  },
  props: {
    isRTLlang: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: ""
    },
    translationKeyInitial: {
      type: String,
      default: ""
    },
    isComparing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      return MultiChoiceService.getSelectedOptions(this.question, this.isComparing);
    },
    otherOptionComment() {
      return MultiChoiceService.getOtherAnswerComment(this.question, this.isComparing);
    },
    isOtherOptionSelected() {
      return MultiChoiceService.isOtherOptionSelected(this.question, this.isComparing);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/multi-choice-other-answer.scss";
</style>
